// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import PasswordRequirementController from "./password_requirement_controller"
application.register("password-requirement", PasswordRequirementController)

import InputMaskController from "./input_mask_controller"
application.register("input-mask", InputMaskController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)

import LoginLinkController from "./login_link_controller"
application.register("login-link", LoginLinkController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import TranslatedFormController from "./translated_form_controller"
application.register("translated-form", TranslatedFormController)

import ContentLanguageController from "./content_language_controller"
application.register("content-language", ContentLanguageController)

import RadioButtonsController from "./radio_buttons_controller"
application.register("radio-buttons", RadioButtonsController)

import ConfirmActionController from "./confirm_action_controller"
application.register("confirm-action", ConfirmActionController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import UserRoleFormController from "./user_role_form_controller"
application.register("user-role-form", UserRoleFormController)

import ModelSelectionController from "./model_selection_controller"
application.register("model-selection", ModelSelectionController)

import MediaUploadController from "./master_media_upload_controller"
application.register("media-upload", MediaUploadController)

import MediaModalController from "./media_modal_controller"
application.register("media-modal", MediaModalController)

import InlineCodeEditorController from "./inline_code_editor_controller"
application.register("inline-code-editor", InlineCodeEditorController)

import JudgeTypeToggleController from "./judge_type_toggle_controller"
application.register("judge-type-toggle", JudgeTypeToggleController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import CriteriaTypeController from "./criteria_type_controller"
application.register("criteria-type", CriteriaTypeController)

import JudgeModeToggleController from "./judge_mode_toggle_controller"
application.register("judge-mode-toggle", JudgeModeToggleController)

import ScoresController from "./scores_controller"
application.register("scores", ScoresController)

import FormSubmitLoaderController from "./form_submit_loader_controller"
application.register("form-submit-loader", FormSubmitLoaderController)

import MasterSearchController from "./master_search_controller"
application.register("master-search", MasterSearchController)

import CompetitionResultsController from "./competition_results_controller"
application.register("competition-results", CompetitionResultsController)

import CopyCriteriasController from "./copy_criterias_controller"
application.register("copy-criterias", CopyCriteriasController)

import ResultPdfStatusController from "./result_pdf_status_controller"
application.register("result-pdf-status", ResultPdfStatusController)

import DocumentCarouselController from "./document_carousel_controller"
application.register("document-carousel", DocumentCarouselController)

import UserDocumentFormController from "./user_document_form_controller"
application.register("user-document-form", UserDocumentFormController)

import NominationPhotosFormController from "./nomination_photos_form_controller"
application.register("nomination-photos-form", NominationPhotosFormController)

import QrScannerModalController from "./qr_scanner_modal_controller"
application.register("qr-scanner-modal", QrScannerModalController)

import CompetitionFiltersController from "./competition_filters_controller"
application.register("competition-filters", CompetitionFiltersController)